// @flow weak

import {GET, PUT, POST, DELETE} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';
import _ from 'lodash/fp';
import {
  STANDARD,
} from '../assortments';

export const SELECT_REQUEST = '@customerOrderView/SELECT_REQUEST';
export const SELECT_FAILURE = '@customerOrderView/SELECT_FAILURE';

export const APARTMENT_CONFIG_GET_REQUEST = '@customerOrderView/APARTMENT_CONFIG_GET_REQUEST';
export const APARTMENT_CONFIG_GET_SUCCESS = '@customerOrderView/APARTMENT_CONFIG_GET_SUCCESS';
export const APARTMENT_CONFIG_GET_FAILURE = '@customerOrderView/APARTMENT_CONFIG_GET_FAILURE';

export const TOGGLE_ROOM = '@customerOrderView/TOGGLE_ROOM';
export const TOGGLE_MENU = '@customerOrderView/TOGGLE_MENU';
export const TOGGLE_HELP = '@customerOrderView/TOGGLE_HELP';

export const SEND_EMAIL_REQUEST = '@customerOrderView/SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = '@customerOrderView/SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAILURE = '@customerOrderView/SEND_EMAIL_FAILURE';

export const OPEN_PRODUCT = '@customerOrderView/OPEN_PRODUCT';
export const CLOSE_PRODUCT = '@customerOrderView/CLOSE_PRODUCT';
export const SELECT_IMAGE = '@customerOrderView/SELECT_IMAGE';

export const ORDER_DATA_GET_REQUEST = '@customerOrderView/ORDER_DATA_GET_REQUEST';
export const ORDER_DATA_GET_SUCCESS = '@customerOrderView/ORDER_DATA_GET_SUCCESS';
export const ORDER_DATA_GET_FAILURE = '@customerOrderView/ORDER_DATA_GET_FAILURE';

export const ORDER_ROW_UPDATE_REQUEST = '@customerOrderView/ORDER_ROW_UPDATE_REQUEST';
export const ORDER_ROW_UPDATE_SUCCESS = '@customerOrderView/ORDER_ROW_UPDATE_SUCCESS';
export const ORDER_ROW_UPDATE_FAILURE = '@customerOrderView/ORDER_ROW_UPDATE_FAILURE';

export const ORDER_ROW_CREATE_REQUEST = '@customerOrderView/ORDER_ROW_CREATE_REQUEST';
export const ORDER_ROW_CREATE_SUCCESS = '@customerOrderView/ORDER_ROW_CREATE_SUCCESS';
export const ORDER_ROW_CREATE_FAILURE = '@customerOrderView/ORDER_ROW_CREATE_FAILURE';

export const ORDER_ROW_REMOVE_REQUEST = '@customerOrderView/ORDER_ROW_REMOVE_REQUEST';
export const ORDER_ROW_REMOVE_SUCCESS = '@customerOrderView/ORDER_ROW_REMOVE_SUCCESS';
export const ORDER_ROW_REMOVE_FAILURE = '@customerOrderView/ORDER_ROW_REMOVE_FAILURE';

export const ORDER_ROWS_UPDATE_REQUEST = '@customerOrderView/ORDER_ROWS_UPDATE_REQUEST';
export const ORDER_ROWS_UPDATE_SUCCESS = '@customerOrderView/ORDER_ROWS_UPDATE_SUCCESS';
export const ORDER_ROWS_UPDATE_FAILURE = '@customerOrderView/ORDER_ROWS_UPDATE_FAILURE';

export const ORDER_ROWS_CLEAR_REQUEST = '@customerOrderView/ORDER_ROWS_CLEAR_REQUEST';
export const ORDER_ROWS_CLEAR_SUCCESS = '@customerOrderView/ORDER_ROWS_CLEAR_SUCCESS';
export const ORDER_ROWS_CLEAR_FAILURE = '@customerOrderView/ORDER_ROWS_CLEAR_FAILURE';

export const SHOW_ALL = '@customerOrderView/SHOW_ALL';
export const SET_PAGE = '@customerOrderView/SET_PAGE';
export const SET_SELECTION = '@customerOrderView/SET_SELECTION';
export const CLEAR = '@customerOrderView/CLEAR';

export const SET_ADVANCED_SELECTION = '@customerOrderView/SET_ADVANCED_SELECTION';
export const SET_ADDITIONAL_SELECTION = '@customerOrderView/SET_ADDITIONAL_SELECTION';

export const TOGGLE_ROOM_PRICE = '@customerOrderView/TOGGLE_ROOM_PRICE';
export const TOGGLE_ADDITIONAL_PRICE = '@customerOrderView/TOGGLE_ADDITIONAL_PRICE';
export const TOGGLE_PRICES = '@customerOrderView/TOGGLE_PRICES';

const selectAdvancedSuccess = (products, slot) => ({
  type: SET_ADVANCED_SELECTION,
  products,
  slot,
});

const selectRequest = (room, slot, productType) => ({
  type: SELECT_REQUEST,
  room,
  slot,
  productType,
});

const selectSlotSuccess = (products, slot) => ({
  type: SET_SELECTION,
  products,
  slot,
});

const selectFailure = error => ({
  type: SELECT_FAILURE,
  error,
});

const orderDataRequest = order => ({
  type: ORDER_DATA_GET_REQUEST,
  order,
});

const orderDataSuccess = (apartmentConfig, orderRows, customRows, extraRows) => ({
  type: ORDER_DATA_GET_SUCCESS,
  apartmentConfig,
  orderRows,
  customRows,
  extraRows,
});

const orderDataFailure = error => ({
  type: ORDER_DATA_GET_FAILURE,
  error,
});

const orderRowRemoveRequest = () => ({
  type: ORDER_ROW_REMOVE_REQUEST,
});

const orderRowRemoveSuccess = rows => ({
  type: ORDER_ROW_REMOVE_SUCCESS,
  rows,
  [NOTIFICATION]: {
    message: 'Order uppdaterad',
  },
});

const orderRowRemoveFailure = error => ({
  type: ORDER_ROW_REMOVE_FAILURE,
  error,
  [NOTIFICATION]: {
    message: 'Nätverksfel, vänligen försök igen',
  },
});

const orderRowUpdateRequest = () => ({
  type: ORDER_ROW_UPDATE_REQUEST,
});

const orderRowUpdateSuccess = (rows, row) => ({
  type: ORDER_ROW_UPDATE_SUCCESS,
  row,
  rows,
  [NOTIFICATION]: {
    message: 'Order uppdaterad',
  },
});

const orderRowUpdateFailure = error => ({
  type: ORDER_ROW_UPDATE_FAILURE,
  error,
  [NOTIFICATION]: {
    message: 'Nätverksfel, vänligen försök igen',
    level: 'error',
  },
});

const orderRowCreateRequest = () => ({
  type: ORDER_ROW_CREATE_REQUEST,
});

const orderRowCreateSuccess = (rows, row) => ({
  type: ORDER_ROW_CREATE_SUCCESS,
  row,
  rows,
  [NOTIFICATION]: {
    message: 'Order uppdaterad',
  },
});

const orderRowCreateFailure = error => ({
  type: ORDER_ROW_CREATE_FAILURE,
  error,
  [NOTIFICATION]: {
    message: 'Nätverksfel, vänligen försök igen',
    level: 'error',
  },
});

const orderRowsUpdateRequest = () => ({
  type: ORDER_ROWS_UPDATE_REQUEST,
});

const orderRowsUpdateSuccess = (rows, row) => ({
  type: ORDER_ROWS_UPDATE_SUCCESS,
  row,
  rows,
  [NOTIFICATION]: {
    message: 'Order uppdaterad',
  },
});

const orderRowsUpdateFailure = error => ({
  type: ORDER_ROWS_UPDATE_FAILURE,
  error,
  [NOTIFICATION]: {
    message: 'Nätverksfel, vänligen försök igen',
    level: 'error',
  },
});

const orderRowsClearRequest = () => ({
  type: ORDER_ROWS_CLEAR_REQUEST,
});

const orderRowsClearSuccess = () => ({
  type: ORDER_ROWS_CLEAR_SUCCESS,
  [NOTIFICATION]: {
    message: 'Order uppdaterad',
  },
});

const orderRowsClearFailure = error => ({
  type: ORDER_ROWS_CLEAR_FAILURE,
  error,
});

export const toggleMenu = show => ({
  type: TOGGLE_MENU,
  show,
});

export const toggleHelp = show => ({
  type: TOGGLE_HELP,
  show,
});

export const toggleRoom = (roomId, expanded) => ({
  type: TOGGLE_ROOM,
  roomId,
  expanded,
});

export const setPage = page => ({
  type: SET_PAGE,
  page,
});

export const openProduct = (product, variant) => ({
  type: OPEN_PRODUCT,
  product,
  variant,
});

export const closeProduct = () => ({
  type: CLOSE_PRODUCT,
});

export const selectImage = image => ({
  type: SELECT_IMAGE,
  image,
});

export const showAll = () => ({
  type: SHOW_ALL,
});

export const clear = () => ({
  type: CLEAR,
});

export const sendEmailRequest = () => ({
  type: SEND_EMAIL_REQUEST,
});

export const sendEmailFailure = error => ({
  type: SEND_EMAIL_FAILURE,
  [NOTIFICATION]: {
    message: 'Nätverksfel, vänligen försök igen',
    level: 'error',
  },
  error,
});

export const sendEmailSuccess = () => ({
  type: SEND_EMAIL_SUCCESS,
  [NOTIFICATION]: {
    message: 'Mail skickat till säljare',
  },
});

export const selectAdditional = () => ({
  type: SET_ADDITIONAL_SELECTION,
});

export const selectAdvanced = (room, slot, productType) => async dispatch => {
  dispatch(selectRequest(room, slot, productType));
  try {
    const products = await GET({endpoint: `/products?productTypeId=${productType.id}&images=1&assortment=${STANDARD}&forceOrderDto=1`}, dispatch);
    dispatch(selectAdvancedSuccess(products, slot));
  } catch (err) {
    dispatch(selectFailure(err));
  }
};

export const sendEmail = (orderId, message) => async dispatch => {
  dispatch(sendEmailRequest());
  try {
    await POST({
      endpoint: `/orders/${orderId}/help`,
      body: {
        message,
      },
      expectBody: false,
    }, dispatch);
    dispatch(sendEmailSuccess());
  } catch (err) {
    dispatch(sendEmailFailure(err));
  }
};

export const selectSlot = (orderId, room, slot) => async dispatch => {
  dispatch(selectRequest(room, slot));
  try {
    const products = await GET({endpoint: `/orders/${orderId}/productslots/${slot.id}/products`}, dispatch);
    dispatch(selectSlotSuccess(products, slot));
  } catch (err) {
    dispatch(selectFailure(err));
  }
};

export const fetchOrderData = (order, apartment) => async dispatch => {
  dispatch(orderDataRequest(order));
  try {
    const fullOrder = await GET({endpoint: `/orders/${order.id}`}, dispatch);
    const apartmentConfig = await GET({endpoint: `/apartmentconfigs/${apartment.apartmentConfigId}`}, dispatch);
    dispatch(orderDataSuccess(apartmentConfig, fullOrder.rows, fullOrder.customRows, fullOrder.extraRows));
  } catch (err) {
    dispatch(orderDataFailure(err));
  }
};

export const createOrderRow = (orderId, slot, variant, config, parentConfig) => async dispatch => {
  dispatch(orderRowCreateRequest());
  try {
    const rows = await POST({
      endpoint: `/orders/${orderId}/rows`,
      body: {
        productSlotId: slot.id,
        productVariantId: !!config ? null : variant.id,
        parentConfigId: !!parentConfig ? parentConfig.id : null,
        configId: !!config ? config.id : null,
      },
    }, dispatch);
    dispatch(orderRowCreateSuccess(rows, _.find({
      productSlotId: slot.id,
      productVariantId: !!config ? null : variant.id,
      parentConfigId: !!parentConfig ? parentConfig.id : null,
      configId: !!config ? config.id : null,
    }, rows)));
  } catch (err) {
    dispatch(orderRowCreateFailure(err));
  }
};

export const updateOrderRow = (row, slot, variant, config, parentConfig) => async dispatch => {
  dispatch(orderRowUpdateRequest());
  try {
    const rows = await PUT({
      endpoint: `/orderrows/${row.id}`,
      body: {
        productSlotId: slot.id,
        productVariantId: !!config ? null : variant.id,
        parentConfigId: !!parentConfig ? parentConfig.id : null,
        configId: !!config ? config.id : null,
      },
    }, dispatch);
    dispatch(orderRowUpdateSuccess(rows, _.find({id: row.id}, rows)));
  } catch (err) {
    dispatch(orderRowUpdateFailure(err));
  }
};

export const removeOrderRow = (rowId, slotId) => async dispatch => {
  dispatch(orderRowRemoveRequest());
  try {
    const rows = await DELETE({
      endpoint: `/orderrows/${rowId}`,
    }, dispatch);
    dispatch(orderRowRemoveSuccess(rows));
  } catch (err) {
    dispatch(orderRowRemoveFailure(err));
  }
};

export const updateOrderRows = (orderId, {standard, clear} = {}) => async dispatch => {
  dispatch(orderRowsUpdateRequest());
  try {
    const rows = await PUT({
      endpoint: `/orders/${orderId}/rows`,
      body: {
        standard,
        clear,
      },
    }, dispatch);
    dispatch(orderRowsUpdateSuccess(rows));
  } catch (err) {
    dispatch(orderRowsUpdateFailure(err));
  }
};

export const clearOrderRows = orderId => async dispatch => {
  dispatch(orderRowsClearRequest());
  try {
    await POST({
      endpoint: `/orders/${orderId}/clearorderrows`,
      expectBody: false,
    }, dispatch);
    dispatch(orderRowsClearSuccess());
  } catch (err) {
    dispatch(orderRowsClearFailure(err));
  }
};

export const toggleRoomPrice = roomId => ({
  type: TOGGLE_ROOM_PRICE,
  roomId,
});

export const toggleAdditionalPrice = () => ({
  type: TOGGLE_ADDITIONAL_PRICE,
});

export const togglePrices = () => ({
  type: TOGGLE_PRICES,
});



// WEBPACK FOOTER //
// ./src/actions/customerOrderView.js